module.exports = __webpack_public_path__ + "static/img/bg-image.4effd47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiangyun/bg-image.jpg
// module id = dKN3
// module chunks = 1